<template>
    <div style="background-color: #F4FAFF; padding-bottom: 20px;">
        <div class="automatic-mode-container raw-container">
            <div class="d-flex flex-column flex-md-row justify-content-sm-center justify-content-md-between">
                <div>
                    <p class="title-text text-center" style="margin-bottom: 0px !important;">
                        Pack & Go
                    </p>
                </div>
                <div class="d-flex mx-md-0 mx-auto flex-column flex-sm-row mt-3 mt-md-0">
                    <div class="d-flex align-items-center print-btn">
                        <button type="button" class="btn d-flex align-items-center print-opt-btn mx-auto">
                            <img src="~@/assets/pack_go/printer-icon-primary-color.svg" style="margin-right: 10px"/>
                            <p class="card-header-action">Print Options</p>
                        </button>
                    </div>
                    <div class="d-flex align-items-center ml-auto">
                        <BInputGroup>
                            <template #append>
                                <BInputGroupText class="search-btn"><font-awesome-icon icon="search" style="color: #ffffff"/></BInputGroupText>
                            </template>
                            <BFormInput class="search-input" placeholder="Search by order or barcode"></BFormInput>
                        </BInputGroup>
                    </div>
                </div>
            </div>
        </div>
        <div class="raw-container">
            <ItemList @open-modal="openModal()" :item_index="selected_item" @next-item="nextItem()" @prev-item="prevItem()"/>
            <OrderTable @open-modal="openModal()" :item_index="selected_item" style="margin-top: 16.5px"/>
        </div>
        
        <div class="footer raw-container">
            <div class="d-flex justify-content-between flex-column flex-lg-row">
                <BCol sm="12" md="12" lg="6" xl="6">
                    <div class="lorem-text">
                        Welcome to the Automatic mode demo!<br><br>
                    Start by selecting the order you’d like to pack using the arrows at the top left of the screen.<br><br>
                    Then, click the circle to mark the item as packed. When the order is fully packed, a label will print automatically.
                    </div>
                </BCol>
                <BCol sm="12" md="12" lg="3" xl="3" class="mt-2 mt-lg-0">
                    <div class="btn-sub-question">Explore the other method?</div>
                    <div>
                        <router-link to="/pack-go">
                            <BButton class="go-back-btn">
                                Go Back
                            </BButton>
                        </router-link>
                    </div>
                </BCol>
            </div>
        </div>
        <BModal v-model="showLoading" no-close-on-backdrop :hide-footer="true" :hide-header="true" :size="'md'" centered title="BootstrapVue">
            <transition name="fade">
                <div v-if="!showPrint" class="modal-style">
                    <img class="transition-style" v-bind:style="{transform: `rotate(${deg}deg)`}" src="~@/assets/pack_go/gear-icon.svg"/>
                    <p>Processing...</p>
                </div>
                <div v-else class="modal-style-two">
                    <img src="~@/assets/pack_go/printer-icon-modal.svg"/>
                    <p>Print Label.</p>
                </div>
            </transition>
        </BModal>
    </div>
</template>

<script>
import ItemList from '@/components/Picking/ItemList.vue';
import OrderTable from '@/components/Picking/OrderTable.vue';
import { BButton, BCol, BFormInput, BInputGroup, BInputGroupText, BModal, BRow } from 'bootstrap-vue';

export default {
    components: {
        BInputGroup,
        BInputGroupText,
        BFormInput,
        ItemList,
        OrderTable,
        BRow,
        BCol,
        BButton,
        BModal,
    },
    data() {
        return {
            showLoading: false,
            showPrint: false,
            deg: 360,
            interval: null,
            counter: 0,
            selected_item: 0,
        }
    },
    methods: {
        rotation() {
            this.showPrint = false
            this.counter++;
            this.deg -= 30;

            if (this.counter >= 3) {
                clearInterval(this.interval);
                this.deg -= 90;
                this.showPrint = true;
                setTimeout(() => {
                    this.showLoading = false
                    this.deg = 360
                    this.$router.push({ path: '/pack-go/print' })
                }, 3000);
            }
        },
        openModal() {
            this.showLoading =  true
            this.interval = setInterval(this.rotation, 1000);
        },
        nextItem() {
            if(this.selected_item === 2) {
                this.selected_item = 0
            } else {
                this.selected_item++
            }
        },
        prevItem() {
            if(this.selected_item === 0) {
                this.selected_item = 2
            } else {
                this.selected_item--
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
}
</script>

<style scoped>
    .raw-container {
        margin-right: auto;
        margin-left: auto;
    }

    .print-btn {
        min-width: 2px;
        padding: 0px;
        margin-right: 20px;
    }

    @media (max-width: 576px) {
        .print-btn {
            margin-right: 0px;
        }
    }

    @media (min-width: 768px) {
        .raw-container {
            width: 750px;
        }
    }
    @media (min-width: 992px) {
    .raw-container {
        width: 970px;
    }
    }
    @media (min-width: 1200px) {
    .raw-container {
        width: 1140px;
    }
    }
    .automatic-mode-container {
        padding: 50px 0px;
    }

    .title-text {
        font-family: "SourceSansProSemibold";
        font-style: normal;
        font-weight: 600;
        font-size: 31px;
        width: 100%;
    }

    .container-header {
        display: flex;
        flex-direction: row;
        width: 100%;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
    }

    .print-btn button{
        color: #F4FAFF;
        background-color: none;
    }

    .print-btn button p{
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        margin-top: auto;
        margin-bottom: auto;
    }

    .input-group {
        width: 320px;
    }

    .search-btn {
        height: 43px;
        background-color: #112857;
        border: 1px solid #112857;
        border-radius: 0px 6px 6px 0px;
    }

    .search-input {
        height: 43px;
        border: 1px solid #112857;
        border-radius: 6px 0px 0px 6px;
    }

    .footer {
        margin-top: 60px;
        background-color: #F4FAFF;
        margin-bottom: 20px;
    }

    .footer-container {
        padding-left: 0px;
        padding-right: 0px;
    }

    .go-back-btn {
        background-color: #1D97FF;
        height: 43px;
        width: 100%;
        border: 1px solid #1D97FF;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        margin-left: auto;
    }

    .lorem-text {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
        display: flex;
        align-items: center;
        color: #212121;
        background-color: #ffffff;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid #C3C5C7;
        border-radius: 6px;
    }

    .btn-sub-question {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #000000;
        margin-bottom: 21px;
    }

    .modal-style {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 26px;
        transition: opacity 0.5s ease;
    }

    .modal-style p {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 23px;
        color: #212121;
        margin-top: 24px;
    }

    .modal-style-two {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 26px;
        transition: opacity 0.5s ease;
    }

    .modal-style-two p {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 23px;
        color: #212121;
        margin-top: 24px;
    }

    .transition-style {
        transition: transform 0.5s ease-in-out;
    }

    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    .print-opt-btn {
        box-shadow: none !important;
        cursor: default !important;
    }

    .print-opt-btn:active {
        box-shadow: none !important;
    }
</style>